module.exports = __webpack_public_path__ + "static/005-e1f16ad2ee91b0ec4022d5fbe89b9318.jpg";